/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RoleTemplateFormModal_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CreateRoleTemplateModal_organization$ref: FragmentReference;
declare export opaque type CreateRoleTemplateModal_organization$fragmentType: CreateRoleTemplateModal_organization$ref;
export type CreateRoleTemplateModal_organization = {|
  +id: string,
  +$fragmentRefs: RoleTemplateFormModal_organization$ref,
  +$refType: CreateRoleTemplateModal_organization$ref,
|};
export type CreateRoleTemplateModal_organization$data = CreateRoleTemplateModal_organization;
export type CreateRoleTemplateModal_organization$key = {
  +$data?: CreateRoleTemplateModal_organization$data,
  +$fragmentRefs: CreateRoleTemplateModal_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateRoleTemplateModal_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleTemplateFormModal_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '5c7ab893abe8aee0e751ead2a447db24';

module.exports = node;
